<template>
  <div>
    <b-form @submit.prevent="searchByAddress">
      <label for="searchBox">
        {{ $t("tripPlan.searchClausule") }}
      </label>
      <b-input-group>
        <b-form-input
          id="searchBox"
          type="text"
          v-model="searchQuery"
          :placeholder="$t('tripPlan.searchClausule')"
        >
        </b-form-input>
        <b-input-group-append lg="6" md="6" sm="12">
          <b-button size="sm" type="submit">
            <i class="tim-icons icon-zoom-split" style="padding-top: 25%"> </i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
  </div>
</template>
    
<script>

export default {
  name: "LeafletMarker",
  props: {
    latitude: Number,
    longitude: Number,
    searchQuery: String
  },
  components: {},
  mixins: [],
  data() {
    return {
      apiKey:
        "As-Vkf2McY-jBXfx3q_vrpwdrFmtyixvHjGFuv90Ak2WD338py0sIQ7wCf5z2D80",
      // searchQuery: "",
    };
  },
  inject: ["getMap"],
  methods: {
    destroy() {
      //   try {
      //     if (infobox) {
      //       let map = this.getMap();
      //       if (map) {
      //         infobox.setMap(null);
      //       }
      //     }
      //   } finally {
      //     this.setItem(null);
      //   }
    },
    searchByAddress() {
      fetch(
        `https://dev.virtualearth.net/REST/v1/Locations/${this.searchQuery}?key=${this.apiKey}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((response) => response.text())
        .then((jsonResponse) => {
          let response = JSON.parse(jsonResponse);
          console.log(response);

          if (response.resourceSets.lenght == 0) return;
          if (response.resourceSets[0].resources.lenght == 0) return;

          const resultResources = response.resourceSets[0].resources[0];
          const latitude = resultResources.point.coordinates[0];
          const longitude = resultResources.point.coordinates[1];
          const fullAddress = resultResources.address.formattedAddress;

          const searchResult = {
            latitude,
            longitude,
            fullAddress,
          };
          console.log(searchResult);
          this.$emit("onSearch", searchResult);
        });
    },
    searchAddressByLatLng(latitude, longitude) {
      fetch(
        `https://dev.virtualearth.net/REST/v1/Locations/${latitude},${longitude}?output=json&key=${this.apiKey}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((response) => response.text())
        .then((jsonResponse) => {
          let response = JSON.parse(jsonResponse);
          if (response.resourceSets.lenght == 0) return;
          if (response.resourceSets[0].resources.lenght == 0) return;

          const resultResources = response.resourceSets[0].resources[0];
          const latitude = resultResources.point.coordinates[0];
          const longitude = resultResources.point.coordinates[1];
          const fullAddress = resultResources.address.formattedAddress;

          const searchResult = {
            latitude,
            longitude,
            fullAddress,
          };
          console.log(searchResult);
          this.$emit("onSearch", searchResult);
        });
    },
  },
  beforeDestroy() {
    this.destroy();
  },
  mounted() {
    this.render();
  },
};
</script>
    